import { BOARDS } from "@/constants/assets";

export const LANES = {
  "posters-social": {
    slug: "posters-social",
    title: "Posters & Social Creatives",
    eyebrow: "Lane 01 · Daily visibility",
    headline1: "Posters that",
    headline2: "stop the scroll.",
    lede: "Daily-visibility creatives engineered for mobile-first promotion. Posters, stories, carousels, catalogs — original layouts, never templates.",
    priceRange: "₹349 — ₹1,499",
    description:
      "Posters, social posts, stories, carousels and catalog visuals from ₹349 to ₹1,499. Original layouts for daily small-business promotion.",
    boardImg: BOARDS.postersSocial,
    offers: [
      { name: "Story / WhatsApp Status Design", price: "₹349", blurb: "Vertical 9:16 creative for Status, IG/FB stories. Quickest entry point." },
      { name: "Basic Poster Design", price: "₹399", blurb: "Single poster with offer + branding. Fast turnaround." },
      { name: "Instagram / Facebook Post", price: "₹499", blurb: "Square 1:1 social post with on-brand layout." },
      { name: "Festival / Occasion Poster", price: "₹499", blurb: "Themed for Diwali, Pongal, Ramadan, New Year, Independence Day, etc." },
      { name: "WhatsApp Catalog Image", price: "₹499", blurb: "Product card optimised for WhatsApp business catalogs." },
      { name: "Offer / Sale Poster", price: "₹599", blurb: "Conversion-led layout for limited-time offers and flash sales." },
      { name: "Standard Business Poster", price: "₹699", blurb: "Brand intro / services / offer poster with stronger hierarchy." },
      { name: "Business Intro Poster", price: "₹999", blurb: "Founder/brand intro poster — perfect for onboarding new audiences." },
      { name: "Facebook Page Banner / Cover", price: "₹999", blurb: "Cover image sized + cropped for FB/IG/LinkedIn page." },
      { name: "Carousel Post Design", price: "₹1,499", blurb: "Multi-slide narrative post (up to 5 slides). ₹250/extra slide." },
      { name: "Premium Campaign Poster", price: "₹1,499", blurb: "Hero-level campaign poster with elevated typography & visual system." },
    ],
    includes: [
      "Original layout — never recycled templates",
      "Tamil / English / bilingual versions on request",
      "Mobile-first hierarchy with thumb-stop framing",
      "Final delivery as PNG + JPG, print-ready PDF on request",
      "1–2 minor revisions inside confirmed scope",
      "Copyright-safe — only client-supplied or licensed assets",
    ],
    faqs: [
      {
        q: "How fast is delivery?",
        a: "Single posters: 24–48 hours once the brief is confirmed. Festival or campaign sets: 2–4 days depending on volume.",
      },
      {
        q: "Can I get Tamil + English versions?",
        a: "Yes. Bilingual layouts are common — share the copy in both languages with the brief and we'll typeset both.",
      },
      {
        q: "What do I need to send?",
        a: "Business name, logo, offer details, product or service photos, language, target platform, and your delivery deadline.",
      },
    ],
    ctaHeadline: "Need a poster live this week?",
  },

  "reels-motion": {
    slug: "reels-motion",
    title: "Reels & Motion Promos",
    eyebrow: "Lane 02 · Short-form video",
    headline1: "Reels that",
    headline2: "earn the watch.",
    lede: "Reel covers, animated business reels, festival reels and premium ad-style motion creatives — built for IG, FB and YouTube Shorts.",
    priceRange: "₹499 — ₹3,499",
    description:
      "Reel covers, animated business reels, festival reels and premium reel ad creatives — ₹499 to ₹3,499.",
    boardImg: BOARDS.reelsBranding,
    offers: [
      { name: "Reel Cover / Thumbnail", price: "₹499", blurb: "Custom cover frame so your reel grid stays visually cohesive." },
      { name: "Basic Reel Creation", price: "₹999", blurb: "Short-form reel with text overlays, music and motion — up to 15s." },
      { name: "Festival / Offer Reel", price: "₹1,499", blurb: "Themed reel with festival visual language and offer push." },
      { name: "Standard Business Reel", price: "₹1,999", blurb: "Brand intro / service explainer reel up to 30s with kinetic type." },
      { name: "Premium Reel Ad Creative", price: "₹3,499", blurb: "Ad-grade motion creative with stronger storytelling and CTA edit." },
      { name: "Ad Reel Creative", price: "₹2,499", blurb: "Reel optimised for Meta Ads placement and conversion-led CTA." },
    ],
    includes: [
      "9:16 vertical, optimised for Reels / Shorts / Stories",
      "Kinetic typography in English / Tamil",
      "Royalty-free music + sound design",
      "Client-supplied footage edited + colour-graded",
      "Final delivery as MP4 + cover frame PNG",
      "Up to 30s per reel (longer available on quote)",
    ],
    faqs: [
      {
        q: "Do you shoot the reels?",
        a: "Editing-only by default. You supply the raw footage and photos; we handle the edit, motion, type and sound. On-location shoots are available on quote.",
      },
      {
        q: "Can the reel be Meta-Ads ready?",
        a: "Yes — for Ad Reel Creative and Premium Reel Ad, we export in the correct codec, length and aspect with safe-zones for ad placement.",
      },
    ],
    ctaHeadline: "Got footage? Let's render the reel.",
  },

  "branding-identity": {
    slug: "branding-identity",
    title: "Branding & Identity",
    eyebrow: "Lane 03 · Identity systems",
    headline1: "Logos. Systems.",
    headline2: "Launch kits.",
    lede: "From a basic logo at ₹2,999 to a full startup launch identity at ₹29,999 — packaged identity work for brands that need consistency.",
    priceRange: "₹999 — ₹29,999",
    description:
      "Logo design, stationery, branding kits, startup launch packs and industry-specific identity systems — ₹999 to ₹29,999.",
    boardImg: BOARDS.reelsBranding,
    offers: [
      { name: "Visiting Card Design", price: "₹999", blurb: "Two-sided business card with on-brand layout. Print-ready." },
      { name: "Letterhead Design", price: "₹999", blurb: "Print + digital letterhead matching your identity system." },
      { name: "Basic Logo Design", price: "₹2,999", blurb: "Wordmark or simple symbol logo. 2 concepts + 1 revision round." },
      { name: "Stationery Kit", price: "₹3,999", blurb: "Visiting card + letterhead + envelope + email signature." },
      { name: "Business Logo Design", price: "₹6,999", blurb: "Full logo system with primary, secondary, monogram and mono variants." },
      { name: "Logo Branding Kit", price: "₹12,999", blurb: "Logo + colour palette + type system + usage guide + stationery." },
      { name: "Healthcare Branding Kit", price: "₹14,999", blurb: "Trust-led identity for clinics, doctors and healthcare brands." },
      { name: "Salon Branding Kit", price: "₹16,999", blurb: "Premium beauty / salon identity with brochure and signage cues." },
      { name: "Menu & Branding Pack", price: "₹16,999", blurb: "Restaurant identity + printable menu system (dine-in + takeaway)." },
      { name: "Startup Brand Identity Pack", price: "₹18,999", blurb: "Logo + colour + type + decks + 5 starter creatives for launch." },
      { name: "Startup Premium Launch Pack", price: "₹29,999", blurb: "Full launch identity + landing visuals + 10 social creatives." },
    ],
    includes: [
      "2–3 concept directions per logo brief",
      "Final logo in SVG + PNG + PDF + favicon",
      "Brand guidelines PDF (colour, type, dos & don'ts)",
      "Stationery & decks at print-ready resolution",
      "Source files retained for 12 months",
      "Up to 2 revision rounds within confirmed scope",
    ],
    faqs: [
      {
        q: "How many logo concepts will I see?",
        a: "Basic logo: 2 directions, 1 revision. Business / Branding kits: 3 directions, 2 revision rounds. Premium launch packs include exploratory mood boards before the concept stage.",
      },
      {
        q: "Do you do trademark / registration?",
        a: "Trademark filing is not included. We deliver original artwork, but legal registration should be done with a qualified trademark professional.",
      },
    ],
    ctaHeadline: "Ready for an identity that compounds?",
  },

  "ads-profile": {
    slug: "ads-profile",
    title: "Ads & Profile Support",
    eyebrow: "Lane 04 · Profile + paid",
    headline1: "Profiles, ads,",
    headline2: "campaigns.",
    lede: "Business profile PDFs, hero banners, Google Business creatives, ad posters, ad reels and campaign sets. Ad spend always separate.",
    priceRange: "₹499 — ₹5,999",
    description:
      "Business profile PDFs, Google Business creatives, ad posters, ad reels, campaign sets and Meta/Google Ads setup support — ₹499 to ₹5,999.",
    boardImg: BOARDS.adsProfile,
    offers: [
      { name: "Google Business Profile Creative", price: "₹699", blurb: "Cover + posts for your Google Business listing." },
      { name: "Ad Poster Creative", price: "₹999", blurb: "Single-image ad creative optimised for Meta placements." },
      { name: "Website Banner / Hero Image", price: "₹1,499", blurb: "Hero banner for your website / landing page above-the-fold." },
      { name: "Ad Reel Creative", price: "₹2,499", blurb: "Motion ad creative engineered for short-form ad placements." },
      { name: "Meta Ads Setup", price: "₹2,999", tag: "Setup", blurb: "Account + pixel + campaign setup. Ad spend separate." },
      { name: "Campaign Creative Set", price: "₹3,999", blurb: "4–6 piece creative set for one campaign — posters + reel + carousels." },
      { name: "Company Profile / Portfolio PDF", price: "₹4,999", blurb: "Designed company profile PDF for sales & BD use." },
      { name: "Google Ads Basic Setup", price: "₹5,999", tag: "Setup", blurb: "Search/Display campaign setup, keywords, ad copy. Ad spend separate." },
      { name: "Monthly Meta Ads Management", price: "₹4,999", tag: "/month", blurb: "Ongoing management — creatives quoted separately." },
    ],
    includes: [
      "Ad spend is never included in design or management fees",
      "Pixel + UTM + conversion tracking setup",
      "Creative variants for A/B testing on quote",
      "Profile PDF delivered with editable source + flat PDF",
      "Monthly performance summary on management plans",
      "Payments only via UPI / official payment links",
    ],
    faqs: [
      {
        q: "Does setup or management cost include my ad budget?",
        a: "No — the ad spend (paid to Meta/Google) is always separate from the design + setup + management fee. We'll always show both numbers clearly before you confirm.",
      },
      {
        q: "What do I need to give for ads setup?",
        a: "Business name, website / landing page URL, target audience, business goal (leads / sales / footfall), and your monthly ad budget so the structure can be planned.",
      },
    ],
    ctaHeadline: "Need a campaign live this month?",
  },

  "monthly-systems": {
    slug: "monthly-systems",
    title: "Monthly Creative Systems",
    eyebrow: "Lane 05 · Recurring engines",
    headline1: "Subscribe to",
    headline2: "consistency.",
    lede: "Universal monthly packs + 7 industry-specific packs. Recurring creative output engineered so your brand shows up every single day.",
    priceRange: "₹4,999 — ₹24,999 / month",
    description:
      "Universal and industry-specific monthly creative packs from ₹4,999 to ₹24,999 per month. Restaurants, salons, clinics, retail, startups, education, real estate.",
    boardImg: BOARDS.monthlyUniversal,
    offers: [
      { name: "Monthly Starter Pack", price: "₹4,999", tag: "/month", blurb: "Core social creatives + 1 reel cover. Best for first-time outsourcers." },
      { name: "Local Shop Starter Pack", price: "₹4,999", tag: "/month", blurb: "Retail-focused starter — offers, stories, festival pushes." },
      { name: "WhatsApp Catalog Pack", price: "₹4,999", tag: "/month", blurb: "Product-card heavy pack optimised for WhatsApp business." },
      { name: "Education Starter Pack", price: "₹6,999", tag: "/month", blurb: "Admission posters + enquiry creatives for institutes." },
      { name: "Beauty Starter Pack", price: "₹6,999", tag: "/month", blurb: "Salon-focused starter pack with bridal + festive cues." },
      { name: "Clinic Starter Creative Pack", price: "₹6,999", tag: "/month", blurb: "Trust-building creatives for clinics + healthcare." },
      { name: "Food Business Starter Pack", price: "₹6,999", tag: "/month", blurb: "Restaurant / cafe daily promotion starter." },
      { name: "Construction Starter Pack", price: "₹7,999", tag: "/month", blurb: "Project showcase + service intro creatives for builders." },
      { name: "Monthly Social Growth Pack", price: "₹9,999", tag: "/month", blurb: "Posters + stories + carousels + 2 reels." },
      { name: "Retail Monthly Pack", price: "₹9,999", tag: "/month", blurb: "Festival pushes, offer creatives, catalog visuals." },
      { name: "Startup Monthly Growth Pack", price: "₹14,999", tag: "/month", blurb: "Launch-stage startup support — creatives + content cues." },
      { name: "Monthly Creative Pro Pack", price: "₹14,999", tag: "/month", blurb: "Full mix + ad creatives + monthly campaign theme." },
      { name: "Restaurant Campaign Pack", price: "₹14,999", tag: "/month", blurb: "Menu-led campaigns + offer pushes + reel covers." },
      { name: "Bridal Campaign Pack", price: "₹14,999", tag: "/month", blurb: "Wedding-season heavy promotion for salons + bridal brands." },
      { name: "Builder Branding Pack", price: "₹24,999", tag: "/month", blurb: "Builder identity + project showcase + monthly real-estate push." },
      { name: "Full Creative Support Pack", price: "₹24,999", tag: "/month", blurb: "Unlimited within scope. Ads + identity refresh + priority briefing." },
    ],
    includes: [
      "Monthly content calendar shared in advance",
      "Mixed output: posters + stories + reel covers + carousels",
      "Industry-specific creative direction",
      "Pause / cancel before next billing cycle (no lock-in)",
      "Priority WhatsApp lane for active subscribers",
      "First draft within 48h of brief confirmation each month",
    ],
    faqs: [
      {
        q: "Can I pause for a month?",
        a: "Yes — pause anytime before your next billing date. Your slot is held and remaining-month output is delivered.",
      },
      {
        q: "What counts as 'within scope'?",
        a: "Each plan lists the exact mix (e.g. 8 posters + 4 stories + 2 reels). New directions / full redesigns count as extra work and are quoted separately.",
      },
      {
        q: "Can I switch packs?",
        a: "Yes — upgrade anytime; downgrades apply from the next billing cycle.",
      },
    ],
    ctaHeadline: "Stop briefing one-offs. Subscribe to consistency.",
  },
};
